import { Store } from 'repatch';

import State from '../core/State';
import { disposeFatalError, setFatalError } from '../reducer/fatalError';
import { addNonFatalError, removeNonFatalError } from '../reducer/nonFatalErrors';

class ErrorPresenter {
  private store: Store<State>;

  constructor({ store }: { store: Store<State> }) {
    this.store = store;
  }

  public showAsNonFatal = (err: Error): void => {
    this.store.dispatch(addNonFatalError(err));
  };

  public showAsFatal = (err: Error, solveTo = '/'): void => {
    if (this.store.getState().fatalError) {
      console.error('ErrorPresenter#showAsFatal() has called in fatal error has been occuring.');
    }

    this.store.dispatch(setFatalError(err, solveTo));
  };

  public removeNonFatal = (err: Error): void => {
    this.store.dispatch(removeNonFatalError(err));
  };

  public resolveFatal = (): void => {
    this.store.dispatch(disposeFatalError());
  };
}

export default ErrorPresenter;
